import { JsonHospitalConfig } from '@quality24/inpatient-typings';

import { AuthUser, AuthUserRole } from '@/inpatient-dashboard/types/auth';
import { useAuth } from './useAuth';

export interface AccountInfo {
  user: AuthUser;
  organization: {
    id: string | null;
    name?: string | null;
  };
  hospital: {
    id: string | null;
    name?: string | null;
    lgpdConsentHtml?: string | null;
    config: JsonHospitalConfig;
  };
  isUserProvisioned: boolean;
  loading: boolean;
}

export const useAccountInfo = (): AccountInfo => {
  const { userData, loading } = useAuth();

  const user: AuthUser = {
    id: userData['custom:user_id'] ?? userData.sub,
    role: userData['custom:role'] || AuthUserRole.GUEST,
    employeeId: userData['custom:employeeId'],
    email: userData.email,
    hospitalId: userData['custom:hospital_id'],
    organizationId: userData['custom:organization_id'],
  };

  const organization = {
    id: userData['custom:organization_id'] ?? null,
    name: userData.organizationName ?? null,
  };

  const hospital = {
    id: userData['custom:hospital_id'] ?? null,
    name: userData.hospitalName ?? null,
    lgpdConsentHtml: userData.hospitalLgpdConsentHtml ?? null,
    config: userData.hospitalConfig || { logos: {} },
  };

  return {
    user,
    organization,
    hospital,
    isUserProvisioned: !!userData.isUserProvisioned,
    loading,
  };
};
